// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cd43177a","239":"ed0c9fad","453":"df8abbac","455":"7581f5d2"}[chunkId] + ".chunk.js";
};